import util from '@/libs/util'


const numberFilter = function (number, fractionSize) {
    // if null or undefined pass it through
    return (number == null) ?
      number :
      util.formatNumber(number, util.formats.PATTERNS[0], util.formats.GROUP_SEP, util.formats.DECIMAL_SEP,
        fractionSize);
}
let filterObj = {}
filterObj.number = numberFilter

export default filterObj